import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function NaviMumbaiAirportToGoaCabs() {



    const cardData = {





keyword: "Navi Mumbai Airport to Goa Cabs",

headingDescription: "Shreesha Tours & Travels offers reliable and comfortable Navi Mumbai Airport to Goa Cab Service for airport transfers, family vacations, honeymoon trips, corporate travel, holiday packages, one-way taxi booking, and round-trip journeys. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for a safe and enjoyable long-distance journey. With experienced drivers, clean and well-maintained vehicles, transparent pricing, doorstep pickup, flexible travel plans, and 24/7 customer support, we ensure a smooth and hassle-free travel experience from Navi Mumbai Airport to Goa.",

topPlaces: [
  {
    title: "Baga Beach Goa",
    description: "Baga Beach is one of Goa's most famous tourist destinations, known for lively beach shacks, water sports, nightlife, seafood restaurants, and beautiful sunset views. Visitors enjoy activities like parasailing, jet skiing, banana boat rides, and relaxing by the Arabian Sea. It is a perfect destination for families, couples, and groups looking for entertainment and beach experiences."
  },
  {
    title: "Calangute Beach Goa",
    description: "Calangute Beach, known as the Queen of Beaches, is one of Goa's largest and most popular beaches. It offers a vibrant atmosphere with shopping markets, beach cafés, adventure activities, and scenic coastal views. Travelers visiting Goa through Navi Mumbai Airport often prefer this area for its hotels, restaurants, and easy access to nearby attractions."
  },
  {
    title: "Basilica of Bom Jesus",
    description: "The Basilica of Bom Jesus is a UNESCO World Heritage Site and one of Goa's most important historical landmarks. The church is famous for its Portuguese architecture and the preserved remains of St. Francis Xavier. Visitors interested in history, culture, and heritage tourism often include this attraction in their Goa sightseeing plans."
  },
  {
    title: "Dudhsagar Waterfalls",
    description: "Dudhsagar Waterfalls is one of India's tallest and most spectacular waterfalls, located on the Goa-Karnataka border. Surrounded by forests and wildlife, it offers an unforgettable nature experience with jeep safaris, trekking routes, and breathtaking views. It is a must-visit attraction for adventure lovers and photographers."
  },
  {
    title: "Fort Aguada",
    description: "Fort Aguada is a historic Portuguese fort famous for its ancient architecture, lighthouse, sea views, and panoramic coastal scenery. Built in the 17th century, the fort provides excellent photography opportunities and attracts travelers interested in Goa's colonial history and heritage."
  },
  {
    title: "Palolem Beach",
    description: "Palolem Beach is a peaceful South Goa destination known for its crescent-shaped coastline, calm waters, beach huts, kayaking, dolphin tours, and relaxing atmosphere. It is ideal for couples, families, and travelers who prefer a quieter beach holiday away from crowded areas."
  },
  {
    title: "Anjuna Beach",
    description: "Anjuna Beach is famous for its scenic coastline, flea market, beach parties, cafés, and vibrant atmosphere. It is a favorite destination among tourists looking for shopping, nightlife, photography, and unique Goan experiences. The surrounding areas also offer beautiful viewpoints and local attractions."
  },
  {
    title: "Candolim Beach",
    description: "Candolim Beach is a premium and peaceful beach destination known for luxury resorts, water activities, restaurants, and relaxing seaside experiences. It is located close to Fort Aguada and Calangute, making it a convenient location for travelers exploring North Goa attractions."
  },
  {
    title: "Panaji City",
    description: "Panaji, the capital city of Goa, is known for colorful streets, Fontainhas Latin Quarter, Mandovi River views, churches, casinos, and cultural attractions. Visitors can explore heritage buildings, local markets, and riverside locations while experiencing Goa's unique blend of Portuguese and Indian culture."
  },
  {
    title: "Vagator Beach",
    description: "Vagator Beach is famous for dramatic red cliffs, Chapora Fort views, beach cafés, and beautiful sunset scenes. It is a popular destination among young travelers, couples, and photographers. The nearby Chapora Fort offers stunning views of the Arabian Sea and surrounding coastline."
  }
],


"services": [
  {
    "name": "Mumbai to Goa Cab",
    "description": "Book Mumbai to Goa Cab for a comfortable, safe, and memorable long-distance journey with professional chauffeurs and premium AC vehicles. Enjoy hassle-free travel from Mumbai to Goa with options like Sedan, Swift Dzire, Hyundai Aura, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and luxury cabs. Our Mumbai Goa cab service is suitable for family vacations, weekend trips, corporate travel, honeymoon tours, and sightseeing with flexible one-way and round-trip booking options."
  },
  {
    "name": "Mumbai to Goa Taxi Fare",
    "description": "Get affordable Mumbai to Goa Taxi Fare with transparent pricing, no hidden charges, and multiple vehicle options according to your travel requirements. Choose reliable chauffeur-driven taxis with comfortable seating, clean interiors, luggage space, and flexible fare packages for one-way drops, return trips, family travel, and corporate journeys between Mumbai and Goa."
  },
  {
    "name": "Mumbai to Goa Taxi",
    "description": "Reserve Mumbai to Goa Taxi for a smooth and convenient road trip experience with experienced drivers, well-maintained vehicles, and 24x7 booking support. Whether traveling for holidays, business meetings, family vacations, or leisure trips, our taxi services provide comfortable rides with Sedan, SUV, Innova, Innova Crysta, Ertiga, and premium cab options."
  },
  {
    "name": "Mumbai to Goa Cab Fare",
    "description": "Check Mumbai to Goa Cab Fare with competitive pricing and customized travel packages for different vehicle categories. Enjoy affordable long-distance transportation with professional chauffeurs, comfortable AC cars, and reliable service for solo travelers, families, groups, and corporate passengers traveling from Mumbai to Goa."
  },
  {
    "name": "Mumbai to Goa Taxi One Way Fare",
    "description": "Book Mumbai to Goa Taxi One Way Fare service for economical one-way drop travel without paying unnecessary return charges. Get comfortable chauffeur-driven taxis with flexible pickup locations, timely departure, spacious luggage capacity, and affordable pricing for a convenient Mumbai to Goa journey."
  },
  {
    "name": "Mumbai to Goa Cab Price",
    "description": "Find Mumbai to Goa Cab Price with transparent rates and premium travel options for every budget. Choose from economical sedans, spacious SUVs, luxury vehicles, and family-friendly cabs with professional drivers for safe and comfortable outstation travel."
  },
  {
    "name": "Mumbai to Goa by Car Fare",
    "description": "Book Mumbai to Goa by Car Fare service for private road travel with flexible booking options and comfortable vehicles. Enjoy a personalized journey with experienced chauffeurs, clean AC cars, and convenient pickup facilities from Mumbai to Goa destinations."
  },
  {
    "name": "Mumbai Airport to Goa Cab",
    "description": "Reserve Mumbai Airport to Goa Cab for direct airport pickup and comfortable long-distance transfers. Get professional chauffeurs, flight-friendly pickup coordination, luggage assistance, and premium vehicles for passengers traveling from Mumbai Airport to Goa."
  },
  {
    "name": "Mumbai Goa Cab Service",
    "description": "Choose Mumbai Goa Cab Service for reliable intercity transportation with experienced drivers, affordable packages, and premium comfort. Our cab services are designed for tourists, families, corporate travelers, and groups looking for safe and convenient Mumbai to Goa travel."
  },
  {
    "name": "Mumbai to Goa Cab Booking",
    "description": "Complete Mumbai to Goa Cab Booking online with quick confirmation, flexible travel schedules, and multiple vehicle choices. Enjoy easy reservation, transparent pricing, professional chauffeurs, and comfortable rides for one-way, round-trip, and customized Goa tour plans."
  },
  {
    "name": "Mumbai to Goa Cab Charges",
    "description": "Get Mumbai to Goa Cab Charges with clear pricing details and affordable travel solutions. Select suitable vehicles based on passenger count, luggage requirements, and travel preferences while enjoying safe and comfortable journeys with experienced drivers."
  },
  {
    "name": "Mumbai to Goa Car Hire",
    "description": "Book Mumbai to Goa Car Hire service for private chauffeur-driven travel with premium vehicles and flexible rental options. Perfect for family trips, corporate travel, sightseeing tours, and long-distance journeys with comfortable AC cars."
  },
  {
    "name": "Mumbai to Goa Taxi Price",
    "description": "Check Mumbai to Goa Taxi Price and choose from affordable cab options including Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUVs. Enjoy reliable transportation with professional chauffeurs, clean vehicles, and transparent pricing."
  },
  {
    "name": "Navi Mumbai Airport to Goa Cabs",
    "description": "Book Navi Mumbai Airport to Goa Cabs for convenient airport pickup and direct travel to Goa. Enjoy comfortable vehicles, professional drivers, luggage assistance, and reliable transportation services available for individuals, families, and business travelers."
  },
  {
    "name": "Navi Mumbai Airport to Goa Cab",
    "description": "Reserve Navi Mumbai Airport to Goa Cab for smooth airport transfers with punctual pickup, experienced chauffeurs, and premium AC vehicles. Travel comfortably from Navi Mumbai Airport to Goa with flexible one-way and round-trip options."
  },
  {
    "name": "Navi Mumbai Airport to Goa Taxi",
    "description": "Choose Navi Mumbai Airport to Goa Taxi for safe and comfortable long-distance travel with verified drivers, spacious vehicles, and affordable pricing. Enjoy stress-free airport transportation with reliable service throughout the journey."
  },
  {
    "name": "Cab from Navi Mumbai Airport to Goa",
    "description": "Hire Cab from Navi Mumbai Airport to Goa for direct airport-to-destination travel with professional chauffeurs and well-maintained vehicles. Suitable for family trips, vacations, corporate travel, and Goa sightseeing tours."
  },
  {
    "name": "Taxi from Navi Mumbai Airport to Goa",
    "description": "Book Taxi from Navi Mumbai Airport to Goa for comfortable private transportation with experienced drivers, clean AC cars, and flexible booking options. Enjoy a safe and convenient journey from airport pickup to Goa destination."
  },
  {
    "name": "Book Cab Navi Mumbai Airport to Goa",
    "description": "Book Cab Navi Mumbai Airport to Goa online with easy reservation, instant confirmation, and multiple vehicle options. Get reliable airport transfer services with professional chauffeurs and comfortable travel facilities."
  },
  {
    "name": "Online Cab Booking Navi Mumbai Airport to Goa",
    "description": "Choose Online Cab Booking Navi Mumbai Airport to Goa for quick and secure reservations with transparent pricing and 24x7 support. Enjoy convenient travel planning with premium vehicles and experienced drivers."
  },
  {
    "name": "Best Cab Navi Mumbai Airport to Goa",
    "description": "Reserve the Best Cab Navi Mumbai Airport to Goa for premium travel experience with clean vehicles, professional chauffeurs, timely pickup, and excellent customer service for long-distance journeys."
  },
  {
    "name": "Cheapest Cab Navi Mumbai Airport to Goa",
    "description": "Book Cheapest Cab Navi Mumbai Airport to Goa with affordable fares, reliable service, comfortable AC vehicles, and experienced drivers without compromising travel quality and safety."
  },
  {
    "name": "Reliable Taxi Navi Mumbai Airport to Goa",
    "description": "Choose Reliable Taxi Navi Mumbai Airport to Goa for safe transportation with professional chauffeurs, well-maintained cars, timely service, and comfortable travel from airport to Goa."
  },
  {
    "name": "One Way Cab Navi Mumbai Airport to Goa",
    "description": "Book One Way Cab Navi Mumbai Airport to Goa for economical drop taxi services with no return charges. Enjoy flexible pickup timings and comfortable private travel."
  },
  {
    "name": "Round Trip Cab Navi Mumbai Airport to Goa",
    "description": "Reserve Round Trip Cab Navi Mumbai Airport to Goa for vacation packages, family tours, and return journeys with flexible schedules and experienced chauffeurs."
  },
  {
    "name": "Outstation Cab Navi Mumbai Airport to Goa",
    "description": "Choose Outstation Cab Navi Mumbai Airport to Goa for long-distance travel with premium vehicles, professional drivers, and affordable packages."
  },
  {
    "name": "Innova Cab Navi Mumbai Airport to Goa",
    "description": "Book Innova Cab Navi Mumbai Airport to Goa for spacious family travel with comfortable seating, extra luggage space, and smooth highway journeys."
  },
  {
    "name": "Innova Crysta Cab Navi Mumbai Airport to Goa",
    "description": "Reserve Innova Crysta Cab Navi Mumbai Airport to Goa for luxury travel with premium interiors, spacious seating, and superior comfort for long-distance trips."
  },
  {
    "name": "Ertiga Cab Navi Mumbai Airport to Goa",
    "description": "Choose Ertiga Cab Navi Mumbai Airport to Goa for affordable family transportation with comfortable seating, clean AC vehicles, and professional chauffeurs."
  },
  {
    "name": "Swift Dzire Cab Navi Mumbai Airport to Goa",
    "description": "Book Swift Dzire Cab Navi Mumbai Airport to Goa for economical sedan travel with experienced drivers, comfortable interiors, and reliable service."
  },
  {
    "name": "Kia Carens Cab Navi Mumbai Airport to Goa",
    "description": "Reserve Kia Carens Cab Navi Mumbai Airport to Goa for premium family travel with spacious interiors, modern comfort features, and professional chauffeur service."
  },
  {
    "name": "Sedan Cab Navi Mumbai Airport to Goa",
    "description": "Choose Sedan Cab Navi Mumbai Airport to Goa for affordable and comfortable airport transfers with AC sedans, professional drivers, and smooth travel."
  },
  {
    "name": "SUV Cab Navi Mumbai Airport to Goa",
    "description": "Book SUV Cab Navi Mumbai Airport to Goa for spacious and comfortable journeys with premium vehicles, extra luggage capacity, and reliable chauffeur-driven service."
  }
],
"tableData": [
  ["Mumbai to Goa Cab", "Mumbai to Goa Taxi Fare"],
  ["Mumbai to Goa Taxi", "Mumbai to Goa Cab Fare"],
  ["Mumbai to Goa Taxi One Way Fare", "Mumbai to Goa Cab Price"],
  ["Mumbai to Goa by Car Fare", "Mumbai Airport to Goa Cab"],
  ["Mumbai Goa Cab Service", "Mumbai to Goa Cab Booking"],
  ["Mumbai to Goa Cab Charges", "Mumbai to Goa Car Hire"],
  ["Mumbai to Goa Taxi Price", "Navi Mumbai Airport to Goa Cabs"],
  ["Navi Mumbai Airport to Goa Cab", "Navi Mumbai Airport to Goa Taxi"],
  ["Cab from Navi Mumbai Airport to Goa", "Taxi from Navi Mumbai Airport to Goa"],
  ["Book Cab Navi Mumbai Airport to Goa", "Online Cab Booking Navi Mumbai Airport to Goa"],
  ["Best Cab Navi Mumbai Airport to Goa", "Cheapest Cab Navi Mumbai Airport to Goa"],
  ["Reliable Taxi Navi Mumbai Airport to Goa", "One Way Cab Navi Mumbai Airport to Goa"],
  ["Round Trip Cab Navi Mumbai Airport to Goa", "Outstation Cab Navi Mumbai Airport to Goa"],
  ["Innova Cab Navi Mumbai Airport to Goa", "Innova Crysta Cab Navi Mumbai Airport to Goa"],
  ["Ertiga Cab Navi Mumbai Airport to Goa", "Swift Dzire Cab Navi Mumbai Airport to Goa"],
  ["Kia Carens Cab Navi Mumbai Airport to Goa", "Sedan Cab Navi Mumbai Airport to Goa"],
  ["SUV Cab Navi Mumbai Airport to Goa", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Navi Mumbai Airport to Goa Cab Service",
    WhyChoosedescription: "Start your Goa trip conveniently from Navi Mumbai Airport with Shreesha Travels. Our chauffeur-driven cabs provide a comfortable and private travel experience for families, couples, tourists, corporate travellers, and holiday groups."
  },
  {
    WhyChooseheading: "Direct Airport Transfer to Goa",
    WhyChoosedescription: "Skip the hassle of multiple transport options after your flight. Our private cabs offer direct pickup from Navi Mumbai Airport and drop service to hotels, resorts, beaches, villas, and popular destinations across Goa."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options for Every Group",
    WhyChoosedescription: "Select from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count, luggage, and comfort requirements."
  },
  {
    WhyChooseheading: "Ideal for Holidays, Business Trips & Group Travel",
    WhyChoosedescription: "Our Navi Mumbai Airport to Goa cabs are perfect for family vacations, honeymoon trips, beach holidays, corporate travel, destination weddings, and group tours."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Cab Booking",
    WhyChoosedescription: "Book a one-way airport cab to Goa or choose a round-trip package with flexible return schedules, sightseeing stops, and customized travel plans."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long-Distance Routes",
    WhyChoosedescription: "Our professional chauffeurs are experienced with Maharashtra-Goa highways and provide safe driving, timely pickups, and a smooth journey throughout the trip."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "Every cab is regularly serviced, sanitized, air-conditioned, and inspected before every journey to ensure a safe, comfortable, and reliable travel experience."
  },
  {
    WhyChooseheading: "Book Navi Mumbai Airport to Goa Cabs with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking assistance, professional chauffeur service, and dependable transportation from Navi Mumbai Airport to Goa."
  }
]

};

const faqData = [
  {
    question: "Can I book a cab from Navi Mumbai Airport to Goa?",
    answer: "Yes, you can book a private chauffeur-driven cab from Navi Mumbai Airport to Goa for a comfortable and direct journey."
  },
  {
    question: "Do you provide one-way cab service from Navi Mumbai Airport to Goa?",
    answer: "Yes, one-way cab bookings are available for passengers travelling directly from Navi Mumbai Airport to Goa."
  },
  {
    question: "Which cars are available for Navi Mumbai Airport to Goa travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a round-trip cab to Goa?",
    answer: "Yes, round-trip Goa cab packages are available with flexible return timings and customized travel plans."
  },
  {
    question: "Is this cab service suitable for family vacations?",
    answer: "Yes, spacious vehicles like Ertiga, Kia Carens, Innova, and Innova Crysta are ideal for families travelling to Goa."
  },
  {
    question: "Can I travel to North Goa and South Goa locations?",
    answer: "Yes, our cabs provide doorstep drop service to all major areas including Panaji, Calangute, Baga, Candolim, Anjuna, Margao, and South Goa destinations."
  },
  {
    question: "Are overnight journeys available from Navi Mumbai Airport to Goa?",
    answer: "Yes, you can schedule your cab according to your preferred departure time, including overnight travel."
  },
  {
    question: "How is the Navi Mumbai Airport to Goa cab fare calculated?",
    answer: "The fare depends on the selected vehicle, travel distance, trip type, toll charges, route, and additional travel requirements."
  },
  {
    question: "Can I add sightseeing stops during my Goa trip?",
    answer: "Yes, customized Goa travel plans with sightseeing stops can be arranged according to your itinerary."
  },
  {
    question: "How can I book Navi Mumbai Airport to Goa Cabs with Shreesha Travels?",
    answer: "Share your flight details, pickup location, travel date, passenger count, destination in Goa, and preferred vehicle to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harish Mehta",
    feedback: "Our journey from Navi Mumbai Airport to Goa was excellent. The driver was professional, the vehicle was comfortable, and the entire trip was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Rao",
    feedback: "We booked a cab for our Goa vacation and had a wonderful experience. The car was clean, spacious, and the service was reliable throughout the journey.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport to Goa Cabs",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-airport-to-goa-cabs.webp",
  "description":
    "Book Navi Mumbai Airport to Goa Cabs with Shreesha Tours & Travels for comfortable and reliable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, Goa trips, family vacations, sightseeing tours, one-way, round-trip, and long-distance journeys from Navi Mumbai Airport to Goa with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-airport-to-goa-cabs"
  }
};





    return (
        <div>

<Helmet>
  <title>Navi Mumbai Airport to Goa Cabs | Goa Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport to Goa Cabs with Shreesha Travels for safe and comfortable outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Goa trips, airport transfers, one-way cab, round trips, family vacations, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Goa Cab, Mumbai to Goa Taxi Fare, Mumbai to Goa Taxi, Mumbai to Goa Cab Fare, Mumbai to Goa Taxi One Way Fare, Mumbai to Goa Cab Price, Mumbai to Goa by Car Fare, Mumbai Airport to Goa Cab, Navi Mumbai Airport to Goa Cab, Navi Mumbai to Goa Taxi, Goa Tour Cab from Mumbai, One Way Cab Mumbai to Goa"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/99.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default NaviMumbaiAirportToGoaCabs;